import React from 'react';
import { Icon } from '@chakra-ui/react';

export const Flag = () => {
	return (
		<Icon>
			<svg
				width="15px"
				height="15px"
				viewBox="0 0 15 15"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M2.5 9.375C2.5 9.375 3.125 8.75 5 8.75C6.875 8.75 8.125 10 10 10C11.875 10 12.5 9.375 12.5 9.375V1.875C12.5 1.875 11.875 2.5 10 2.5C8.125 2.5 6.875 1.25 5 1.25C3.125 1.25 2.5 1.875 2.5 1.875V9.375Z"
					stroke="#8C8C8C"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M2.5 13.75V9.375"
					stroke="#8C8C8C"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</Icon>
	);
};
